// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer .title-section {
    font-size: 20px;

    border-bottom-width: 2px;
}

footer ul{
    list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/utils/components/footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;;IAEf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["footer .title-section {\n    font-size: 20px;\n\n    border-bottom-width: 2px;\n}\n\nfooter ul{\n    list-style: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
